/**
 * @memberof module:util
 * @function
 * @name getTimeInMinSec
 * @description Seconds to be converted to get time in minutes and seconds format.
 *
 * @param {number} sec - Seconds
 * @returns {string}
 *
 * @example
 * console.log(getTimeInMinSec(72)); //1 min 12 sec
 * console.log(getTimeInMinSec(8)); //8 sec
 */

export const getTimeInMinSec = (sec) => {
  sec = Number(sec);
  sec = isNaN(sec) ? 0 : sec;

  // console.log({ sec });

  let min = 0;
  if (sec / 60 >= 1) {
    min = parseInt(sec / 60);
    sec = sec - min * 60;
  }
  let timeStr;
  if (min >= 1) {
    timeStr = `${min} min ${sec} sec`;
  } else {
    timeStr = `${sec} sec`;
  }
  // if all remaining time is ran out i.e. min = 0, sec <= 0
  if (min <= 0 && sec <= 0) {
    timeStr = '';
  }

  return timeStr || '';
};
